import React, { useCallback, useEffect, useState } from "react";
import "./TouchFeedback.scss";

interface TouchingState {
    isTouching: boolean;
    x: number;
    y: number;
    isTouchDevice: boolean;
}

interface IProps {
    onTouch: () => void;
}

export function TouchFeedback({ onTouch }: IProps) {
    const [touchState, setTouchState] = useState<TouchingState>({isTouching: false, x: 0, y: 0, isTouchDevice: true});

    const handleStartTouch = useCallback(({clientX, clientY, touches}: any) => {
        const x = clientX ?? (touches[0] as any as Touch).clientX;
        const y = clientY ?? (touches[0] as any as Touch).clientY;
        onTouch();
        setTouchState({
            isTouching: true,
            x,
            y,
            isTouchDevice: true,
        })
    }, [onTouch]);

    useEffect(() => {
        const handleTouchMove = ({clientX, clientY, touches}: any) => {
            const x = clientX ?? (touches[0] as any as Touch).clientX;
            const y = clientY ?? (touches[0] as any as Touch).clientY;
            setTouchState((prevState) => {
                return {
                    ...prevState,
                    x,
                    y
                }
            });
        };
        const handleEndTouch = (e: any) => {
            setTouchState((prevState) => {
                return {
                    ...prevState,
                    isTouching: false,
                }
            });

        };
        document.addEventListener('touchstart', handleStartTouch);
        document.addEventListener('mousedown', handleStartTouch);
        document.addEventListener('touchmove', handleTouchMove);
        document.addEventListener('mousemove', handleTouchMove);
        document.addEventListener('touchend', handleEndTouch);
        document.addEventListener('mouseup', handleEndTouch);

        return () => {
            document.removeEventListener('touchstart', handleStartTouch);
            document.removeEventListener('mousedown', handleStartTouch);
            document.removeEventListener('touchmove', handleTouchMove);
            document.removeEventListener('mousemove', handleTouchMove);
            document.removeEventListener('touchend', handleEndTouch);
            document.removeEventListener('mouseleave', handleEndTouch);
        }
    }, [handleStartTouch]);

    const style = {
        transform: `translateX(calc(-50% + ${touchState.x}px)) translateY(calc(-50% + ${touchState.y}px))`,
    }

    return (
        <div className={`touch-feedback ${touchState.isTouching ? 'touching' : ''} ${touchState.isTouchDevice ? 'is-touch-device' : ''}`} style={style} />
    )
}
